<template>
    <div class="container">
        <md-dialog :md-active.sync="modalCreaCuenta" :md-click-outside-to-close="false">
            <md-dialog-title class="text-center">
                {{ labels.title }}
            </md-dialog-title>
            <md-dialog-content>
                <b-row class="">
                    <b-col cols="3" class="text-left">
                        <h5>{{ labels.contable }}</h5>
                    </b-col>
                    <b-col cols="9" lg="9" class="text-left">
                        <select v-model="contable" id="" class="form-control" @change="f_cambia_contable">
                            <option value=""> {{ labels.select }} </option>
                            <option value="1"> {{ labels.yes }} </option>
                            <option value="0"> {{ labels.not }} </option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="3" class="text-left">
                        <h5>{{ labels.actual }}</h5>
                    </b-col>
                    <b-col cols="1" lg="9" class="text-left">
                        <select v-model="actual" id="" class="form-control">
                            <option value=""> {{ labels.select }} </option>
                            <option value="1"> {{ labels.yes }} </option>
                            <option value="0"> {{ labels.not }} </option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="">
                    <b-col cols="3" class="text-left">
                        <h5>{{ labels.operacion }}</h5>
                    </b-col>
                    <b-col cols="1" lg="9" class="text-left">
                        <select v-model="operacion" id="" class="form-control">
                            <option value=""> {{ labels.select }} </option>
                            <option value="+"> {{ labels.sumar }} </option>
                            <option value="-"> {{ labels.restar }} </option>
                        </select>
                    </b-col>
                </b-row>
                <b-row class="" v-if="showFormulacion">
                    <b-col cols="3" class="text-left">
                        <h5>{{ labels.formulacion }}</h5>
                    </b-col>
                    <b-col cols="1" lg="9" class="text-left">
                        <input v-if="administrador" type="radio" value="m" id="" v-model="chk" class="ml-3"> <span v-if="administrador" >Valor Manual</span>
                        <input type="radio" value="s" id="" v-model="chk" class="ml-3"> <span>Suma</span>
                        <input type="radio" value="n" id="" v-model="chk" class="ml-3"> <span>Niif</span>
                        <input v-if="administrador" type="radio" value="a" id="" v-model="chk" class="ml-3"> <span v-if="administrador" >Ajuste Consolidacion</span>
                        <input v-if="administrador" type="radio" value="ac" id="" v-model="chk" class="ml-3"> <span v-if="administrador" >Ajuste Combinacion</span>
                    </b-col>
                </b-row>

                <b-row class="" v-if="showSuma">
                    <b-col cols="3" class="text-left">
                        <h5>Suma:</h5>
                    </b-col>
                    <b-col cols="1" lg="9" class="text-left">
                        <md-field>
                            <!-- <label>Number</label> -->
                            <md-input v-model="sumNiv" type="text"></md-input>
                        </md-field>
                    </b-col>
                </b-row>
                <!-- Contenido de pestañas -->
                <div class="tab-content">
                    <!-- Pestaña NIIF -->
                    <div v-if="showNiif" class="niif-selection-container">
                        <div class="search-bar">
                            <md-field class="search-field">
                                <md-input v-model="searchNiif" :placeholder="labels.searchPlaceholder"
                                    @input="f_nuevo_criterio_niif()" />
                            </md-field>
                            <md-field class="search-field">
                                <md-input v-model="searchNivel" :placeholder="labels.searchPlaceholderNivel"
                                    @input="f_nuevo_criterio_niif()" />
                            </md-field>
                            <div class="selection-info">
                                {{ labels.selected }}: {{ selectedNiifs.length }}/{{ listNiif.length }}
                            </div>
                        </div>

                        <div class="niif-table-container">
                            <table class="niif-table">
                                <thead>
                                    <tr>
                                        <th class="checkbox-column">
                                            <md-checkbox :md-checked="selectAll" @change="toggleSelectAll" />
                                        </th>
                                        <th class="niif-column">NIIF</th>
                                        <th class="desc-column">Descripción</th>
                                        <th class="level-column">Nivel 1</th>
                                        <th class="level-desc-column">Desc. Nivel 1</th>
                                        <th class="level-column">Nivel 2</th>
                                        <th class="level-desc-column">Desc. Nivel 2</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="niif in filteredNiif" :key="niif.id">
                                        <td class="checkbox-column">
                                            <md-checkbox v-model="niif._selected" @change="onNiifCheckboxChange(niif)"
                                                class="custom-checkbox">
                                            </md-checkbox>
                                        </td>
                                        <td class="niif-column">{{ niif.niif }}</td>
                                        <td class="desc-column" :title="niif.nameNiif || niif.descripcion">
                                            {{ niif.nameNiif || niif.descripcion }}
                                        </td>
                                        <td class="level-column">{{ niif.primer_nivel }}</td>
                                        <td class="level-desc-column"
                                            :title="getFirstLevelDescription(niif.namePrimerNivel)">
                                            {{ getFirstLevelDescription(niif.namePrimerNivel) }}
                                        </td>
                                        <td class="level-column">{{ niif.segundo_nivel }}</td>
                                        <td class="level-desc-column"
                                            :title="getSecondLevelDescription(niif.nameSegundoNivel)">
                                            {{ getSecondLevelDescription(niif.nameSegundoNivel) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="filteredNiif.length === 0" class="no-results">{{ labels.noResults }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <!-- Pestaña CUENTA -->
                    <div v-if="showCuenta" class="cuenta-selection-container">
                        <div class="search-bar">
                            <md-field class="search-field">
                                <md-input v-model="searchCuenta" :placeholder="labels.searchPlaceholderCuenta"
                                    @input="f_nuevo_criterio_cuenta()" />
                            </md-field>
                        </div>

                        <div class="cuenta-table-container">
                            <table class="cuenta-table">
                                <thead>
                                    <tr>
                                        <th class="checkbox-column">
                                            <md-checkbox :md-checked="selectAll" @change="toggleSelectAllCuenta" />
                                        </th>
                                        <th class="cuenta-column">CUENTA</th>
                                        <th class="desc-column">Descripción</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="cuenta in filteredCuenta" :key="cuenta.id">
                                        <td class="checkbox-column">
                                            <md-checkbox v-model="cuenta._selected"
                                                @change="onCuentaCheckboxChange(cuenta)"
                                                class="custom-checkbox"></md-checkbox>
                                        </td>
                                        <td class="cuenta-column">{{ cuenta.cuenta }}</td>
                                        <td class="desc-column" :title="cuenta.nameCuenta || cuenta.descripcion">
                                            {{ cuenta.nameCuenta || cuenta.descripcion }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="filteredCuenta.length === 0" class="no-results">{{ labels.noResults }}
                            </div>
                        </div>
                    </div>
                </div>
                <md-dialog-actions class="mt-3">
                    <md-button class="md-primary" @click="guardaCuenta">{{ labels.save }}</md-button>
                    <md-button class="md-accent" @click="clicked">{{ labels.close }}</md-button>
                </md-dialog-actions>
            </md-dialog-content>
        </md-dialog>
    </div>
</template>

<script>
import PlanCuentas from "../../services/PlanCuentas"
import Company from "../../services/Company"
import PlanConsolidacion from '../../services/PlanConsolidacion';
import Nivel from '../../services/Nivel';

export default {
    name: "CreaCuenta",
    props: ["modalCreaCuenta", "nivelSelected", "vigComSelected", "cuentasCreadas"],
    data: () => ({
	administrador: false,
        contable: false,
        cuenta: "",
        actual: "",
        operacion: "",
        showCuenta: false,
        showFormulacion: false,
        chk: "",
        showSuma: false,
        showNiif: false,
        showConsolidado: false,
        listNiif: [],
        searchCuenta: "",
        searchNiif: "",
        searchNivel: "",
        selectedNiifs: [],
        listLevel: [],
        selVigencia: "",
        listVigencia: [],
        listCompany: [],
        arrNiif: [],
        sumNiv: "",
        criterioC: "",
        criterioD: "",
        listadoCuentas: [],
        listCuentas: [],
        showCuentas: [],
        listCuentasNew: [],
        selectAll: false,
        listFirstLevel: [],
        listSecondLevel: [],
        filteredNiif: [],
        filteredCuenta: [],

    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Crear Detalle",
                    select: "Seleccione...",
                    save: "Guardar",
                    close: "Cerrar",
                    contable: "Contable:",
                    criterio: "Criterio:",
                    yes: "SI",
                    not: "NO",
                    account: "Cuenta:",
                    actual: "Actual:",
                    operacion: "Operación:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Vigencia:",
                    company: "Compañía:",
                    searchPlaceholderCuenta: "Buscar CUENTA...",
                    searchPlaceholder: "Buscar NIIF...",
                    searchPlaceholderNivel: "Buscar Nivel...",
                    selected: "Seleccionados",
                    noResults: "No se encontraron resultados",
                    tabNiif: "NIIFs",
                    consolidado: "Consolidado",
                }
            } else {
                return {
                    title: "Create Detail",
                    select: "Select...",
                    save: "Save",
                    close: "Close",
                    contable: "Accountant:",
                    criterio: "Search:",
                    yes: "YES",
                    not: "NO",
                    account: "Account:",
                    actual: "Actual:",
                    operacion: "Operation:",
                    sumar: "+",
                    restar: "-",
                    formulacion: "Formula:",
                    vigencia: "Validity:",
                    company: "Company:",
                    searchPlaceholderCuenta: "Search ACOUNT...",
                    searchPlaceholder: "Search NIIF...",
                    searchPlaceholderNivel: "Search Level...",
                    selected: "Selected",
                    noResults: "No result found",
                    tabNiif: "NIIFs",
                    consolidado: "Consolidated",
                }
            }
        }
    },
    methods: {
        f_nuevo_criterio_niif() {
            this.filteredNiif = this.f_filteredNiif()
        },
        f_filteredNiif() {
            const niif = this.searchNiif?.toLowerCase() || "";
            const nivel = this.searchNivel?.toLowerCase() || "";

            const listParcial =
                this.listNiif.filter(n =>
                    n.niif.toString().includes(niif) ||
                    (n.nameNiif && n.nameNiif.toLowerCase().includes(niif)) ||
                    (n.descripcion && n.descripcion.toLowerCase().includes(niif)))
            return listParcial.filter(n =>
                n.primer_nivel.toString().includes(nivel) ||
                n.segundo_nivel.toString().includes(nivel) ||
                (n.namePrimerNivel && n.namePrimerNivel.toLowerCase().includes(nivel)) ||
                (n.nameSegundoNivel && n.nameSegundoNivel.toLowerCase().includes(nivel)))
        },
        f_nuevo_criterio_cuenta() {
            this.filteredCuenta = this.f_filteredCuenta()
        },
        f_filteredCuenta() {
            const cuenta = "^" + (this.searchCuenta?.toLowerCase() || "")
            return this.listCuenta.filter(n => n.cuenta.match(cuenta))
        },
        getFirstLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion : '-';
        },
        getSecondLevelDescription(levelDescripcion) {
            return levelDescripcion ? levelDescripcion : '-';
        },
        clearFields() {
            this.niif = "";
            this.descripcion = "";
            this.primerNivel = "";
            this.segundoNivel = "";
            this.actual = "";
            this.operacion = "";
            this.niifSelect = [];
            this.listNiif = [];
            this.selectedNiifs = [];
            this.hasUnsavedChanges = false;
            this.selectAll = false;
            this.searchNiif = "";
            this.searchNivel = "";
        },
        f_cambia_contable() {
            if (this.contable === "1") {
                this.selectedNiifs = [];
                this.listNiif.forEach(n => n._selected = false);
                this.searchedNiifs = this.listNiif
                this.selectedNiifs = [];
            }
            if (this.contable === "0") {
                this.selectedCuentas = [];
                this.listCuenta.forEach(n => n._selected = false);
                this.searchedCuentas = this.listCuenta
                this.selectedCuentas = [];
            }
        },
        onNiifCheckboxChange(niif) {
            if (niif._selected) {
                if (!this.selectedNiifs.some(n => n.niif === niif.niif)) this.selectedNiifs.push(niif);
            } else {
                this.selectedNiifs = this.selectedNiifs.filter(n => n.niif !== niif.niif);
            }
            this.updateSelectAllState();
        },
        onCuentaCheckboxChange(cuenta) {
            if (cuenta._selected) {
                if (!this.selectedCuentas.some(n => n.cuenta === cuenta.cuenta)) this.selectedCuentas.push(cuenta);
            } else {
                this.selectedCuentas = this.selectedCuentas.filter(n => n.cuenta !== cuenta.cuenta);
            }
            this.updateSelectAllStateCuenta();
        },
        updateSelectAllState() {
            if (this.filteredNiif.length === 0) {
                this.selectAll = false;
                return;
            }
            this.selectAll = this.filteredNiif.every(n => n._selected);
        },
        updateSelectAllStateCuenta() {
            if (this.filteredNCuentaiif.length === 0) {
                this.selectAllCuenta = false;
                return;
            }
            this.selectAllCuenta = this.filteredCuenta.every(n => n._selected);
        },
        toggleSelectAll() {
            this.filteredNiif.forEach(n => {
                if (n._selected === true) {
                    n._selected = false
                } else {
                    n._selected = true
                }
            });
            this.selectedNiifs = this.listNiif.filter(n => n._selected);
        },
        toggleSelectAllCuenta() {
            this.filteredCuenta.forEach(n => {
                if (n._selected === true) {
                    n._selected = false
                } else {
                    n._selected = true
                }
            });
            this.selectedCuentas = this.listCuentas.filter(n => n._selected);
        },
        guardaCuenta() {
            if (this.chk == 'n') {
                if (this.selectedNiifs.length == 0) {
                    this.$toast.success("Niif sin seleccionar")
                    return
                }
            }
            if (this.vigComSelected.vigencia == "") {
                this.$toast.error("El campo vigencia debe estar diligenciado")
            } else if (this.vigComSelected.compania == "") {
                this.$toast.error("El campo compañía debe estar diligenciado")
            } else if (this.contable == "") {
                this.$toast.error("El campo contable debe estar diligenciado")
            } else if (this.actual == "") {
                this.$toast.error("El campo actual debe estar diligenciado")
            } else if (this.operacion == "") {
                this.$toast.error("El campo operación debe estar diligenciado")
            } else {

                let dataInfo = {
                    "vigencia": this.vigComSelected.vigencia,
                    "compania": this.vigComSelected.compania,
                    "codReporte": this.vigComSelected.codReporte,
                    "contable": this.contable,
                    "cuenta": this.contable == 1 ? this.selectedCuentas : "",
                    "actual": this.actual,
                    "operacion": this.operacion,
                    "nivel": this.nivelSelected,
                    "formulacion": this.contable == 0 ? this.chk : "",
                    "formSumaNiv": this.chk == "s" ? this.sumNiv : "",
                    "formNiif": this.chk == "n" ? this.selectedNiifs : "",
                    'idUser': this.$store.state.userId
                }
                // console.log(dataInfo)
                if (this.$route.params.tipo == 'directo') {
                    Nivel.createNewCuentaNivelEfe(dataInfo)
                        .then((res) => {
                            // console.log(res)
                            this.$toast.success(res.data.message)
                        })
                        .catch((err) => {
                            console.log(err)
                            if (err.response.status == 412) {
                                this.$toast.error(err.response.data.message)
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.reloadTable()
                            }, 2500);
                        })
                } else {
                    Nivel.createNewCuentaNivelEfeInd(dataInfo)
                        .then((res) => {
                            // console.log(res)
                            this.$toast.success(res.data.message)
                        })
                        .catch((err) => {
                            console.log(err)
                            if (err.response.status == 412) {
                                this.$toast.error(err.response.data.message)
                            }
                        })
                        .finally(() => {
                            setTimeout(() => {
                                this.reloadTable()
                            }, 3000);
                        })
                }
            }
        },
        clicked() {
            this.contable = ""
            this.listadoCuentas = []
            this.actual = ""
            this.operacion = ""
            this.chk = ""
            this.showFormulacion = false
            this.sumNiv = ""
            this.arrNiif = []

            this.$emit('clicked', false);
        },
        reloadTable() {
            this.$emit('reloadTable', this.nivelSelected, this.vigComSelected.vigencia, this.vigComSelected.compania, this.vigComSelected.codReporte)
        },
        f_criterio_cuenta() {
            const criterio = "^" + this.criterioC
            if (this.criterioC.length == 0) {
                this.showCuentas = this.listCuentas
            } else {
                this.showCuentas = this.listCuentas.filter(
                    (cuenta) => cuenta.cuenta.match(criterio) > 0)
            }
        },
        f_criterio_descripcion() {
            if (this.criterioD.length == 0) {
                this.showCuentas = this.listCuentas
            } else {
                this.showCuentas = this.listCuentas.filter(
                    (cuenta) => cuenta.descripcion.toUpperCase().indexOf(this.criterioD.toUpperCase()) >= 0)
            }
        },
    },
    mounted() {
        this.clearFields();
	if	(this.$route.name == "nivelesADM") {
		this.administrador=true
	}
        PlanCuentas.getVigenciaPlancuentas()
            .then((result) => {
                // console.log(result.data.getVigencia)
                this.listVigencia = result.data.getVigencia
            })
            .catch((err) => {
                console.log(err)
            })

        Company.getAllCompanies()
            .then((result) => {
                // console.log(result)
                this.listCompany = result.data.companies
            })
            .catch((err) => {
                console.log(err)
            })
        PlanConsolidacion.getPlanConsPorCompVige(this.vigComSelected.vigencia, this.vigComSelected.codReporte)
            .then((res) => {
                this.listNiif = res.data.planConsNiif || [];
                this.listNiif.forEach(n => n._selected = false);
                this.selectedNiifs = [];
                this.filteredNiif = this.f_filteredNiif()

            })
            .catch((err) => console.log(err))

        let form = {
            'compania': this.vigComSelected.compania,
            'vigencia': this.vigComSelected.vigencia,
            'cuentasList': this.cuentasCreadas
        }

        if (this.$route.params.tipo == 'directo') {
            Nivel.cuentasNoCreadas(form)
                .then((res) => {
                    this.listCuenta = res.data.cuentas || [];
                    this.listCuenta.forEach(n => n._selected = false);
                    this.selectedCuentas = [];
                    this.filteredCuenta = this.f_filteredCuenta()
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            Nivel.cuentasNoCreadasInd(form)
                .then((res) => {
                    this.listCuenta = res.data.cuentas || [];
                    this.listCuenta.forEach(n => n._selected = false);
                    this.selectedCuentas = [];
                    this.filteredCuenta = this.f_filteredCuenta()
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    watch: {
        contable(valNew) {
            // console.log(valNew)
            if (valNew == 0) {
                this.showCuenta = false
                this.showFormulacion = true
                this.listCuentas = []

            } else if (valNew == 1) {

                this.showCuenta = true
                this.showFormulacion = false
                this.showSuma = false
                this.showNiif = false
                this.chk = ""
                this.listLevel = []
                this.arrNiif = []
            }
        },
        chk(valNew) {
            this.showSuma = false
            this.showNiif = false
            this.showConsolidado = false
            if (valNew == 'n') {
                this.showNiif = true
            }
            if (valNew == 's') {
                this.showSuma = true
            }
            if (valNew == 'c') {
                this.showConsolidado = true
            }
        },
    }
}
</script>

<style scoped>
/* Estilos base */
.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
    max-height: 80vh;
    overflow-y: auto;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.form-field-full {
    width: 100%;
}

/* Labels y campos */
.field-label {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.custom-field {
    margin: 0;
}

.modern-select {
    width: 100%;
    padding: 12px 16px;
    border: 1px solid #bdc3c7;
    border-radius: 4px;
    background: white;
    font-size: 14px;
    color: #2c3e50;
    outline: none;
    transition: border-color 0.2s ease;
}

.modern-select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.1);
}

/* Pestañas */
.tabs-container {
    border: 1px solid #e9ecef;
    border-radius: 4px;
    overflow: hidden;
}

.tabs-header {
    display: flex;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.tab-button {
    flex: 1;
    padding: 12px 16px;
    background: none;
    border: none;
    border-bottom: 3px solid transparent;
    font-weight: 600;
    color: #6c757d;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.tab-button:hover {
    background: #e9ecef;
    color: #495057;
}

.tab-button.active {
    color: #3498db;
    border-bottom-color: #3498db;
    background: white;
}

.tab-content {
    background: white;
}

/* Barras de búsqueda comunes */
.search-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
}

.search-field {
    margin: 0;
    flex: 1;
    max-width: 300px;
}

.selection-info {
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
}

/* Tablas comunes */
.niif-table-container,
.redefiniciones-table-container {
    max-height: 400px;
    overflow-y: auto;
}

.niif-table,
.redefiniciones-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 13px;
}

.niif-table thead,
.redefiniciones-table thead {
    position: sticky;
    top: 0;
    z-index: 100;
}

.niif-table th,
.redefiniciones-table th {
    background: #34495e;
    color: white;
    padding: 8px 4px;
    text-align: left;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 2px solid #2c3e50;
}

.niif-table td,
.redefiniciones-table td {
    padding: 4px 4px;
    border-bottom: 1px solid #e9ecef;
    line-height: 1.2;
    vertical-align: middle;
}

.niif-table tr,
.redefiniciones-table tr {
    height: 28px;
}

.niif-table tr:hover,
.redefiniciones-table tr:hover {
    background: #f8f9fa;
}


.cuenta-table-container,
.redefiniciones-table-container {
    max-height: 400px;
    overflow-y: auto;
}

.cuenta-table,
.redefiniciones-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    font-size: 13px;
}

.cuenta-table thead,
.redefiniciones-table thead {
    position: sticky;
    top: 0;
    z-index: 100;
}

.cuenta-table th,
.redefiniciones-table th {
    background: #34495e;
    color: white;
    padding: 8px 4px;
    text-align: left;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    white-space: nowrap;
    border-bottom: 2px solid #2c3e50;
}

.cuenta-table td,
.redefiniciones-table td {
    padding: 4px 4px;
    border-bottom: 1px solid #e9ecef;
    line-height: 1.2;
    vertical-align: middle;
}

.cuenta-table tr,
.redefiniciones-table tr {
    height: 28px;
}

.cuenta-table tr:hover,
.redefiniciones-table tr:hover {
    background: #f8f9fa;
}


/* Columnas ordenables */
.sortable {
    cursor: pointer;
    transition: background-color 0.2s ease;
    user-select: none;
    position: relative;
}

.sortable:hover {
    background: #2c3e50;
}

.sort-indicator {
    margin-left: 4px;
    font-weight: bold;
    font-size: 12px;
}

/* Columnas específicas */
.checkbox-column,
.action-column {
    width: 50px;
    text-align: center;
    padding: 0 2px;
}

.niif-column {
    width: 70px;
    font-weight: 600;
    color: #2c3e50;
    text-align: center;
}

.desc-column {
    width: 180px;
    min-width: 180px;
    max-width: 180px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.level-column {
    width: 60px;
    text-align: center;
    font-weight: 600;
}

.level-desc-column {
    width: 140px;
    min-width: 140px;
    max-width: 140px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;
}

.formulation-column {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 11px;
    color: #6c757d;
}

/* Componentes específicos */
.custom-checkbox {
    margin: 0;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container) {
    background: #e74c3c !important;
    border-color: #e74c3c !important;
}

:deep(.custom-checkbox.md-checked .md-checkbox-container::after) {
    border-color: white !important;
}

.select-btn {
    margin: 0;
    padding: 0;
    min-width: 30px;
    height: 30px;
}

:deep(.select-btn .md-ripple) {
    padding: 4px;
}

:deep(.select-btn .b-icon) {
    font-size: 16px;
    color: #3498db;
}

.clickable-row {
    cursor: pointer;
    transition: background-color 0.2s ease;
}

.clickable-row:hover {
    background: #e3f2fd !important;
}

/* Estados y mensajes */
.no-results {
    padding: 20px;
    text-align: center;
    color: #6c757d;
    font-style: italic;
    font-size: 14px;
}

/* Acciones del diálogo */
.dialog-actions {
    padding: 16px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    background: #f8f9fa;
}

.actions-left,
.actions-right {
    display: flex;
}

.actions-right {
    gap: 12px;
}

/* Botones */
.delete-btn {
    background: #e74c3c !important;
    color: white !important;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
}

.delete-btn,
.cancel-btn,
.save-btn {
    font-size: 14px;
    padding: 8px 16px;
    min-width: 90px;
}

.delete-btn:hover {
    background: #c0392b !important;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Scroll personalizado */
.niif-table-container::-webkit-scrollbar,
.redefiniciones-table-container::-webkit-scrollbar {
    width: 6px;
}

.niif-table-container::-webkit-scrollbar-track,
.redefiniciones-table-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.niif-table-container::-webkit-scrollbar-thumb,
.redefiniciones-table-container::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
}

.niif-table-container::-webkit-scrollbar-thumb:hover,
.redefiniciones-table-container::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Tooltips */
.desc-column:hover::after,
.level-desc-column:hover::after,
.formulation-column:hover::after {
    content: attr(title);
    position: absolute;
    background: #333;
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 1000;
    white-space: normal;
    max-width: 300px;
}

/* Responsive */
@media (max-width: 768px) {
    .form-group {
        grid-template-columns: 1fr;
        gap: 16px;
    }

    .form-container {
        padding: 16px;
    }

    .dialog-actions {
        padding: 12px 16px;
        flex-direction: column;
        gap: 10px;
    }

    .actions-left,
    .actions-right {
        width: 100%;
        justify-content: center;
    }

    .delete-btn,
    .cancel-btn,
    .save-btn {
        width: 100%;
        font-size: 13px;
        padding: 10px;
    }

    .search-bar {
        flex-direction: column;
        gap: 10px;
        align-items: stretch;
    }

    .search-field {
        max-width: 100%;
    }

    .niif-table-container,
    .redefiniciones-table-container {
        max-height: 300px;
    }

    .tabs-header {
        flex-direction: column;
    }

    .tab-button {
        text-align: center;
        border-bottom: 1px solid #e9ecef;
        border-right: none;
    }

    .tab-button.active {
        border-bottom: 3px solid #3498db;
        border-right: none;
    }

    .desc-column,
    .level-desc-column,
    .formulation-column {
        max-width: 120px;
        min-width: 120px;
    }
}
</style>
